<template>
  <div>
    <Card :title="title || '保单基本信息'">
      
      <Form :label-width="125" class="mt15">
        <Row>
          <!-- 保单 -->
          <template v-if="type == 'policy'">
            <Col span="12">
              <FormItem label="保障状态：">
                {{ info.statusName }}
              </FormItem>
            </Col>
            <Col span="12" >
              <FormItem label="保单号：">
                <span>{{info.policyNo}}</span>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="保单创建时间：">
                {{ info.createTime }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="参保公司：">
                {{ info.companyName }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="联系方式：">
                {{ info.phone }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="投保单号：">
                <a
                  :href="'#/my/customizedLineWork/insuranceDetail/' + info.billNo"
                  target="_blank"
                  rel="opener"
                  >{{ info.billNo }}</a>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="结算状态：">
               {{ info.settlementStatusName }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="结算凭证：">
                <a :href="info.settlementAttachmentUrl" target="_blank">下载</a>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="结算记录：">
                <a @click="openSettleRecord">查看</a>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="发票状态：">
                {{ info.invoiceStatusName }}
              </FormItem>
            </Col>
            <Col span="12" v-if="info.invoiceAttachmentUrl">
              <FormItem label="发票附件：">
                  <a :href="info.invoiceAttachmentUrl" target="_blank">查看</a>
              </FormItem>
            </Col>
          </template>
          <!-- 投保单 -->
          <template v-if="type == 'insurance'">
            <Col span="12">
              <FormItem label="投保单状态：">
                {{ info.statusName }}
              </FormItem>
            </Col>
            <Col span="12" >
              <FormItem label="投保单号：">
                <span>{{ info.billNo }}</span>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="投保单创建时间：">
                {{ info.createTime }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="参保公司：">
                {{ info.companyName }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="联系电话：">
                {{ info.phone }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="保单号：">
                <a :href="'#/my/customizedLineWork/policyDetail/'+(info.policyNo)" target="_blank" rel="opener" class="lineFeed">{{ info.policyNo }}</a>
              </FormItem>
            </Col>
            <Col span="24" v-if="info.attachments&&info.attachments.length>0">
              <FormItem label="投保单附件：">
                <span v-if="info.attachments[0]">{{ info.attachments[0].fileName }}</span>
                <a v-if="info.attachments[0]" :href="info.attachments[0].fileUrl" target="_blank" rel="opener" class="ml15">查看</a>
                <a @click="showImg" class="ml15">更多</a>
                <a @click="downFile" class="ml15">下载投保单</a>
              </FormItem>
            </Col>
          </template>
        </Row>
      </Form>
    </Card>
    <Modal
      v-model="modal"
      title="投保单附件"
      :mask-closable="false"
      width="60%">
      <Table border :columns="columns" :data="info.attachments">
          <template slot-scope="{ row }" slot="action">
              <a :href="row.fileUrl" rel="opener" target="_blank">查看</a>
          </template>
      </Table>
      <div slot="footer">

      </div>
    </Modal>
    <Modal
      v-model="settleModal"
      title="结算记录"
      :mask-closable="false"
      width="70%">
        <Table border :columns="settleColumns" :data="settleList">
          <template slot-scope="{ row }" slot="action">
            <a :href="row.settlementAttachmentUrl" v-if="row.settlementAttachmentUrl" rel="opener" target="_blank">下载结算凭证</a>
          </template>
        </Table>
		  <div slot="footer"></div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default() {
        return {};
      }
    },
    title: String,
    type: {
      type: String,
      default() {
        return "policy";
      }
    }
  },
  data(){
    return {
      modal: false,
			columns:[
				{title:'操作时间',key:'createTime'},
				{title:'文件名',key:'fileName'},
				{title:'操作',slot: 'action'},
			],
      settleModal:false,
      settleColumns:[
        {title:'结算时间',key:'settlementTime',minWidth:this.$columnW.L},
        {title:'结算人',key:'settlementUserName',minWidth:this.$columnW.M},
        {title:'审核状态',key:'auditStatusName',minWidth:this.$columnW.M},
        {title:'审核人',key:'auditAdminName',minWidth:this.$columnW.M},
        {title:'审核时间',key:'auditTime',minWidth:this.$columnW.L},
        {title:'审核备注',key:'auditRemark', minWidth:this.$columnW.XL},
        {title:'操作',slot:'action', width:this.$columnW.M}
      ],
      settleList:[]
    }
  },
  methods: {
    showImg(){
			this.modal = true;
		},
    openSettleRecord(){
      this.$nextTick(()=>{
        this.$axios.post('/casual/policy/settlement/list',{
          policyNo: this.info.policyNo
        }).then(res=>{
            this.settleList = res || [];
            this.settleModal = true;
        })
      })
    },
    // 下载投保单
    downFile(){
      this.$axios.post('/casual/insurance/attachement/download.json',{
        billNo: this.info.billNo
      }).then(res=>{
        console.log(res,'00000000000')
        window.open(res)
      })
    }
  }
};
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedLineWork/common/PolicyBasicInfo.vue